import { Navigate, useLocation } from 'react-router-dom';

/**
 * `/skills/*` → `/agents/*` — the Skills hub was renamed to Agents (2026-09).
 * Keeps the rest of the path (`/skills/client_reporting` → `/agents/client_reporting`)
 * and the query string, so bookmarks and deep links keep resolving.
 */
const LegacySkillsRedirect = () => {
  const { pathname, search, hash } = useLocation();
  const target = pathname.replace(/^\/skills(?=\/|$)/, '/agents');
  return <Navigate to={`${target}${search}${hash}`} replace />;
};

export default LegacySkillsRedirect;
